<template>
  <v-btn class="normal-btn-text elevation-0 rounded-tag-small ml-2"
         :loading="loadingPdf"
         @click="gerarPdf">
    <v-icon>mdi-file-pdf-box</v-icon>
    Gerar PDF
  </v-btn>
</template>

<script>
import FinalizacaoService from './finalizacao-service';

export default {
  props: {
    compraId: String,
  },
  data() {
    return {
      loadingPdf: false,
    };
  },
  methods: {
    gerarPdf() {
      this.loadingPdf = true;
      return FinalizacaoService.generatePdf(this.compraId)
        .then(({ data }) => {
          const blob = new Blob([data], { type: 'application/pdf' });
          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl);
        })
        .finally(() => {
          this.loadingPdf = false;
        });
    },
  },
};
</script>
